// FORÇAR LOGS ANTES DE QUALQUER IMPORTAÇÃO
window.__DEBUG_LOGS__ = [];
const originalConsoleLog = console.log;
console.log = function(...args) {
  window.__DEBUG_LOGS__.push({ type: 'log', args, time: new Date().toISOString() });
  originalConsoleLog.apply(console, args);
};

const originalConsoleError = console.error;
console.error = function(...args) {
  window.__DEBUG_LOGS__.push({ type: 'error', args, time: new Date().toISOString() });
  originalConsoleError.apply(console, args);
};

console.log('🚀 [Main] SCRIPT CARREGADO - INÍCIO');
console.log('[Main] Timestamp:', new Date().toISOString());

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';

console.log('[Main] Imports concluídos');

// Logs iniciais - FORÇAR EXIBIÇÃO
console.log('%c[Main] ====== INICIANDO APLICAÇÃO ======', 'background: #222; color: #bada55; font-size: 16px; padding: 4px;');
console.log('[Main] Inicializando aplicação...');
console.log('[Main] Ambiente:', import.meta.env.MODE);
console.log('[Main] VITE_API_URL:', import.meta.env.VITE_API_URL);
console.log('[Main] VITE_AUTH_URL:', import.meta.env.VITE_AUTH_URL);
console.log('[Main] VITE_CLIENT_ID:', import.meta.env.VITE_CLIENT_ID);

// Verificar se root existe
const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('[Main] ERRO: Elemento #root não encontrado!');
  document.body.innerHTML = '<h1 style="color: red; padding: 20px;">ERRO: Elemento #root não encontrado!</h1>';
} else {
  console.log('[Main] Elemento root encontrado, renderizando...');
  
  try {
    const root = ReactDOM.createRoot(rootElement);
    console.log('[Main] Root criado, renderizando App...');
    
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    
    console.log('[Main] Aplicação renderizada com sucesso');
    console.log('[Main] Total de logs até agora:', window.__DEBUG_LOGS__.length);
  } catch (error) {
    console.error('[Main] ERRO ao renderizar:', error);
    console.error('[Main] Stack:', error.stack);
    rootElement.innerHTML = `<h1 style="color: red; padding: 20px;">ERRO: ${error.message}</h1><pre>${error.stack}</pre>`;
  }
}

// Registrar Service Worker após renderização (não bloquear)
setTimeout(() => {
  import('./app/offline/swRegistration').catch((err) => {
    console.error('[Main] Erro ao importar swRegistration:', err);
  });
}, 100);

console.log('✅ [Main] SCRIPT CARREGADO - FIM');

